module.exports = __webpack_public_path__ + "img/15.ffa6a01b.png";